<template>
  <div class="classDiv">
    <div style="padding-bottom: 60px">
      <header>
        <div class="headerDiv" v-on:click="backHistory"  @click="">
          <!--<img src="@/assets/img/back.png" alt="">-->
          <van-icon name="arrow-left" />
          <p style="color: #000000">红包卡卷</p>
        </div>
      </header>
    </div>
    <!--<van-sidebar style="height: 100%" v-model="activeKey">-->
    <!--<van-sidebar-item title="标签名称" />-->
    <!--<van-sidebar-item title="标签名称" />-->
    <!--<van-sidebar-item title="标签名称" />-->
    <!--</van-sidebar>-->
    <!--<div style="width:100%;height: 200px;">-->
      <!--<van-swipe :autoplay="10000"  style="width:95%;margin: auto" class="swiper">-->
        <!--<van-swipe-item v-for="(image, index) in images" :key="index" >-->
          <!--<img :src="image" style="width: 100%" @click="Preview_img(images,index)"/>-->
        <!--</van-swipe-item>-->
      <!--</van-swipe>-->
    <!--</div>-->
    <van-tabs v-model="active" @click="selectUserCoupon">
      <van-tab title="全部">
        <div class="cardList" v-for="(item,index) in list">
          <div class="cardListLeft">
              <p style="color: #FFFFFF"><span style="font-size: 20px">￥</span><span style="font-size: 30px;">{{item.reduction_price}}</span></p>
              <p style="font-size: 12px">满{{item.full_price}}元可用</p>
              <!--<span class="useNow">立即使用</span>-->
          </div>
          <div class="cardListRight">
            <p>{{item.title}}</p>
            <p>{{item.valid_start_time}}&nbsp;-&nbsp;{{item.valid_end_time}}</p>
          </div>
        </div>

      </van-tab>
      <van-tab title="未使用">
        <div class="cardList" v-for="(item,index) in list">
          <div class="cardListLeft">
            <p style="color: #FFFFFF"><span style="font-size: 20px">￥</span><span style="font-size: 30px;">{{item.reduction_price}}</span></p>
            <p style="font-size: 12px">满{{item.full_price}}元可用</p>
            <span class="useNow">立即使用</span>
          </div>
          <div class="cardListRight">
            <p>{{item.title}}</p>
            <p>{{item.valid_start_time}}&nbsp;-&nbsp;{{item.valid_end_time}}</p>
          </div>
        </div>
      </van-tab>
      <van-tab title="已使用"></van-tab>
      <van-tab title="已过期"></van-tab>
    </van-tabs>
    <!--<van-coupon-cell-->
      <!--:coupons="coupons"-->
      <!--:chosen-coupon="chosenCoupon"-->
      <!--@click="showList = true"-->
    <!--/>-->
    <!-- 优惠券列表 -->
    <!--<van-popup-->
      <!--v-model="showList"-->
      <!--round-->
      <!--position="bottom"-->
      <!--style="height: 90%; padding-top: 4px;"-->
    <!--&gt;-->
      <!--<van-coupon-list-->
        <!--:coupons="coupons"-->
        <!--:chosen-coupon="chosenCoupon"-->
        <!--:disabled-coupons="disabledCoupons"-->
        <!--@change="onChange"-->
        <!--@exchange="onExchange"-->
      <!--/>-->
    <!--</van-popup>-->
    <van-tabbar route  active-color="#ff2500">
      <van-tabbar-item replace to="/home" icon="wap-home-o">
        商城
      </van-tabbar-item>
      <van-tabbar-item replace to="/homeClass" icon="wap-home-o">
        分类
      </van-tabbar-item>
      <van-tabbar-item replace to="/newShop" icon="wap-home-o">
        购物车
      </van-tabbar-item>

      <van-tabbar-item replace to="/myShop" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import {ImagePreview} from 'vant';//引入预览
  import Vue from 'vue';
  import { CouponCell, CouponList } from 'vant';

  Vue.use(CouponCell);
  Vue.use(CouponList);
  const coupon = {
    available: 1,
    condition: '无使用门槛\n最多优惠12元',
    reason: '',
    value: 150,
    name: '优惠券名称',
    startAt: 1489104000,
    endAt: 1514592000,
    valueDesc: '1.5',
    unitDesc: '元',
  };

  export default {
    data () {
      return {
        all:false,
        activeKey:1,
        active: 0,
        items: [
//          { text: '分组 1',id:0 }, { text: '分组 2',id:2 }
        ],
        list:[],
        codeId:"",
        images: [
          'https://img.yzcdn.cn/vant/apple-1.jpg',
          'https://img.yzcdn.cn/vant/apple-2.jpg'
        ],
        SwiperImg: [
          "https://m.360buyimg.com/mobilecms/s750x366_jfs/t1/39343/4/1551/48272/5cbd71f4E329401dc/579b33f530a1402d.jpg!cr_1125x549_0_72!q70.jpg.dpg",
          "https://m.360buyimg.com/mobilecms/s750x366_jfs/t1/34869/14/3703/113972/5cb953c1E4294d8ea/b73c538710f5c462.jpg!cr_1125x549_0_72!q70.jpg.dpg",
          "https://m.360buyimg.com/mobilecms/s750x366_jfs/t1/39343/4/1551/48272/5cbd71f4E329401dc/579b33f530a1402d.jpg!cr_1125x549_0_72!q70.jpg.dpg",
          "https://m.360buyimg.com/mobilecms/s750x366_jfs/t1/34729/14/3948/120618/5cbeee07Efbe17ec5/d57ddd4fbbbc09e0.jpg!cr_1125x549_0_72!q70.jpg.dpg",
          "https://m.360buyimg.com/mobilecms/s750x366_jfs/t1/34423/17/5378/97852/5cbecd7bE73730c2f/76e5359d8fb3a1e1.jpg!cr_1125x549_0_72!q70.jpg.dpg"
        ],
        chosenCoupon: -1,
        coupons: [coupon],
        disabledCoupons: [coupon],
        showList:false,

      }
    },
    methods: {
      backHistory(){
        this.$router.push("/")
      },
      onChange(index) {
        this.showList = false;
        this.chosenCoupon = index;
      },
      onExchange(code) {
        this.coupons.push(coupon);
      },
      toClass(item){
        console.log(item)
        this.$router.push({
          path:"/classification",
          query:{
            id:item.id,
            text:item.title
          }
        })
      },
      Preview_img(images, index) {
        ImagePreview({
          images: images,//图片数组
          showIndex: true,
          loop: false,
          startPosition: index
        })
      },
      // 选中单个商品


      selectUserCoupon(){//分类
        console.log(this.active)
        var obj={}
        switch (this.active){
          case 0:
            obj={
              user_id :localStorage.getItem("userid"),
            }
            break;
          case 1:
            obj={
              user_id :localStorage.getItem("userid"),
              status:1
            }
            break;
          case 2:
            obj={
              user_id :localStorage.getItem("userid"),
              status:2
            }
            break;
          case 3:
            obj={
              user_id :localStorage.getItem("userid"),
              status:3
            }
            break;
        }
        this.$api.selectUserCoupon(obj)
          .then(res=>{
           this.list=res.data
            console.log(this.list)
//            this.onChange(0)
          })
      },

    },
    mounted(){
      this.selectUserCoupon()
      console.log(this.codeId)
//     this.homeClassRight()
    },

  }
</script>
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  .classDiv{
    width: 100%;
    /*height: 100%;*/
    /*background: #e4e4e4;*/
    padding-bottom: 60px;
  }
  header{
    width: 100%;
    height: 50px;
    /*background:#ff2500 ;*/
    position: fixed;
    z-index: 200;
    top: 0;
    background: #ffffff;
  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
  .cardListLeft{
    width: 100PX;
    height: 100PX;
    background: #62AEFB;
    border-radius: 10px;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #FFFFFF;
    margin-left: 10px;
  }
.useNow{
  border: solid 1px #FFFFFF;
  /*PADDING: 2PX;*/
  background: #ffffff;
  color: #62AEFB;
  border-radius: 10px;
  padding: 3px 8px;
  font-size: 10px;
}
  .cardListLeft p{
    /*margin-bottom: 10px;*/
  }
  .cardList{
    /*border-top: solid 5px #e4e4e4;*/
    display: flex;
    align-items: center;
    background: #ffffff;
    padding: 10px;
    margin: 10px 0;
    border-radius: 10px;
    border-top: solid 10px #E4E4E4;
  }
  .cardListRight{
    margin-left: 25px;
    line-height: 30px;
  }


</style>



// WEBPACK FOOTER //
// src/components/shop/cardRoll.vue